import { cn } from "@/lib/cn";
import logoLight from "@/assets/haevn-logo-light.png";
import logoDark from "@/assets/haevn-logo-dark.png";

/**
 * Official HAEVN logo lockup (intertwined monogram + wordmark).
 * Renders the black-on-transparent asset on light themes and the
 * white-on-transparent asset on dark themes. Both PNGs ship from
 * `/app/frontend/src/assets/`.
 *
 * The native aspect ratio is roughly 4.6:1; we constrain by height and let
 * width auto-scale so the lockup remains crisp and proportional.
 *
 * Sizes are tuned for SaaS density:
 *   sm  — favicon-sized inline use (rare)
 *   md  — default navigation lockup (~28px tall)
 *   lg  — hero / footer / presentation chrome
 */
const heightMap = {
  sm: "h-5",   // 20px
  md: "h-7",   // 28px
  lg: "h-9",   // 36px
  xl: "h-12",  // 48px
};

export const Logo = ({ className, size = "md", title = "HAEVN" }) => {
  const h = heightMap[size] || heightMap.md;
  return (
    <span
      className={cn("relative inline-flex select-none", className)}
      data-testid="haevn-logo"
      aria-label={title}
      role="img"
    >
      {/* Light theme variant (black artwork) */}
      <img
        src={logoLight}
        alt=""
        draggable="false"
        aria-hidden="true"
        className={cn(h, "w-auto block dark:hidden")}
      />
      {/* Dark theme variant (white artwork) */}
      <img
        src={logoDark}
        alt=""
        draggable="false"
        aria-hidden="true"
        className={cn(h, "w-auto hidden dark:block")}
      />
    </span>
  );
};

export default Logo;
